import cn from 'clsx';
import React from 'react';

import { Button, Heading1, useDeviceType } from '@cian/ui-kit';
import { IProgramCardProps, ProgramCard } from 'shared/components/ProgramCard';
import { ETestIds } from 'shared/constants/testIds';

import { ContainerInner } from '../ContainerInner';
import styles from './styles.css';

export interface IProgramsBlockProps {
  programs: IProgramCardProps[];
  onCtaClick: () => void;
}

export const ProgramsBlock: React.FC<IProgramsBlockProps> = ({ programs, onCtaClick }) => {
  const deviceType = useDeviceType();

  return (
    <div className={cn(styles['root'], styles[deviceType])} data-testid={ETestIds.ProgramsBlock}>
      <ContainerInner>
        <div className={cn(styles['title'], styles[deviceType])}>
          <Heading1 fontWeight="700">Какие есть программы</Heading1>
        </div>
      </ContainerInner>
      <ContainerInner variant="scrollArea">
        <ul className={cn(styles['grid'], styles[deviceType])}>
          {programs.map(program => (
            <li key={program.title} className={styles['grid-item']}>
              <ProgramCard {...program} />
            </li>
          ))}
        </ul>
      </ContainerInner>
      <ContainerInner>
        <div className={cn(styles['cta'], styles[deviceType])}>
          <Button fullWidth={deviceType === 'phone'} size="L" onClick={onCtaClick}>
            Заполнить анкету на Циане
          </Button>
        </div>
      </ContainerInner>
    </div>
  );
};
